import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import { useUpgradePlan } from 'hooks/billing/useUpgradePlan';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Feature } from '../../../../../../../../pb/subscription/v1/addon_pb';
import { UpsellCard } from '../../upsell-card/UpsellCard';
import { UsageProgressCard } from '../../usage-progress-card/UsageProgressCard';
import { useMonthlyOrderUsage } from '../hooks/useMonthlyOrderUsage';
import { useUsageUpsellCard } from '../hooks/useUsageUpsellCard';

const UNLIMITED = '-1';

// Monthly order usage of the current subscription with an upgrade prompt next to it, for plans with a limited monthly order count
export const DashboardUsageProgressCard: React.FC = () => {
    const { t } = useTranslation();
    const { currentSubscription, addons, goToPlan } = useCurrentSubscriptionHelper();
    const { handle: upgradePlanHandle } = useUpgradePlan();
    const { status, used, limit, progress, progressTone, badge, description, actionLabel } = useMonthlyOrderUsage();

    const carrierLimit = useMemo(() => {
        const providerLimit = addons.find((addon) => addon.name === Feature.PACKAGE_PROVIDER_LIMIT);
        if (!providerLimit || providerLimit.value === UNLIMITED) return undefined;
        return parseInt(providerLimit.value, 10);
    }, [addons]);

    const upsellCard = useUsageUpsellCard(status);

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <div className="md:col-span-2">
                <UsageProgressCard
                    title={t('DASHBOARD.USAGE_PROGRESS_CARD.TITLE')}
                    planName={currentSubscription?.name}
                    usageText={t('DASHBOARD.USAGE_PROGRESS_CARD.USAGE', { used, limit })}
                    progress={{ value: progress, tone: progressTone }}
                    statusBadge={badge}
                    description={description}
                    carrierLimit={carrierLimit}
                    actions={[{ label: actionLabel, onClick: () => goToPlan(upgradePlanHandle) }]}
                />
            </div>
            <UpsellCard {...upsellCard} />
        </div>
    );
};
